import type { ThinkingLevel } from "@elyracode/agent-core";

export const DEFAULT_THINKING_LEVEL: ThinkingLevel = "medium";
